module.exports = __webpack_public_path__ + "img/icon_check.beac73cc.png";